import { render, staticRenderFns } from "./AddVideo.vue?vue&type=template&id=7658529f&scoped=true"
import script from "./AddVideo.vue?vue&type=script&lang=js"
export * from "./AddVideo.vue?vue&type=script&lang=js"
import style0 from "./AddVideo.vue?vue&type=style&index=0&id=7658529f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7658529f",
  null
  
)

export default component.exports